import { DateFormat } from '../../enums/dateFormatEnum'
import moment from 'moment'
import { languages } from '../../components/langContext/enum/languagesEnum'

const SEMAINE_EN = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const SEMAINE_FR = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi']

export const dateAvecPoints = (date: Date, locale: string) => {
	return date && date.toString() !== 'Invalid Date' ? new Intl.DateTimeFormat(locale, {
		day: '2-digit',
		month: '2-digit',
		year: '2-digit'
	}).format(new Date(date)).replace(/\//g, '.') : ''
}

/**
 * Get date with format
 */
export const getDateFormat = (date: string | undefined, format: DateFormat) => {
	return !!date ? moment(date).format(format) : ''
}

/**
 * Formatage de la date selon le format en paramètre
 *
 * @param inputDate
 * @param format
 */
export const formatageDate = (inputDate: string, format: string) => {
	// parse the input date
	const date = new Date(inputDate)

	//extract the parts of the date
	const day = date.getDate()
	const month = date.getMonth() + 1
	const year = date.getFullYear()

	//replace the month
	format = format.replace('MM', month.toString().padStart(2, '0'))

	//replace the year
	if (format.indexOf('yyyy') > -1) {
		format = format.replace('yyyy', year.toString())
	} else if (format.indexOf('yy') > -1) {
		format = format.replace('yy', year.toString().substr(2, 2))
	}

	//replace the day
	format = format.replace('dd', day.toString().padStart(2, '0'))

	return format
}

export const formatDateLong = (date: Date, locale: string) => {
	return date && date.toString() !== 'Invalid Date' ? new Intl.DateTimeFormat(locale, {
		day: '2-digit',
		month: 'long',
		year: 'numeric'
	}).format(new Date(date)) : ''
}

export const formatJourSemaine = (inputDate: string, locale: string) => {
	const date = new Date(inputDate)

	const jourSemaine = date.getDay()
	const semaineTraduite = locale === languages.FR ? SEMAINE_FR : SEMAINE_EN
	const jourSemaineTraduit = semaineTraduite[jourSemaine]
	const jour = formatDateLong(date, locale)

	const a = locale === languages.FR ? 'à' : 'at'
	const heures = date.getHours().toString().padStart(2, '0')
	const minutes = date.getMinutes().toString().padStart(2, '0')

	return `${jourSemaineTraduit} ${jour} ${a} ${heures}:${minutes}`
}
